export class EventoUsoCertificado {

}
